import { createRoute } from "@tanstack/react-router";
import { requireAdmin } from "@/lib/authGuards";
import ClientDetailContainer from "@/features/admin/components/ClientDetail/ClientDetailContainer";
import ClientContainer from "@/features/admin/pages/ClientContainer";
import ClientAddContainer from "@/features/admin/pages/ClientAddContainer";
import DashboardContainer from "@/features/admin/pages/DashboardContainer";
import RequestsContainer from "@/features/admin/pages/RequestsContainer";
import RateLimitContainer from "@/features/admin/pages/RateLimitContainer";
import type { AnyRoute } from "@tanstack/react-router";

export function createAdminRoutes(rootRoute: AnyRoute) {
  const adminParent = createRoute({
    getParentRoute: () => rootRoute,
    path: "/admin",
    beforeLoad: requireAdmin,
    staticData: { layout: "admin" },
  });

  const adminDashboardRoute = createRoute({
    getParentRoute: () => adminParent,
    path: "dashboard",
    component: DashboardContainer,
  });

  const adminClientRoute = createRoute({
    getParentRoute: () => adminParent,
    path: "client",
    component: ClientContainer,
  });

  const adminClientAddRoute = createRoute({
    getParentRoute: () => adminParent,
    path: "client/add",
    component: ClientAddContainer,
  });

  const adminClientDetailRoute = createRoute({
    getParentRoute: () => adminParent,
    path: "client/$clientId",
    component: ClientDetailContainer,
    validateSearch: (search: Record<string, unknown>) => ({
      clientName: search.clientName ? String(search.clientName) : undefined,
    }),
  });

  const adminClientEditRoute = createRoute({
    getParentRoute: () => adminParent,
    path: "client/edit",
    component: ClientAddContainer,
    validateSearch: (search: Record<string, unknown>) => ({
      clientId: search.clientId ? String(search.clientId) : undefined,
      clientName: search.clientName ? String(search.clientName) : undefined,
      mode: search.mode ? String(search.mode) : undefined,
    }),
  });

  const adminRequestsRoute = createRoute({
    getParentRoute: () => adminParent,
    path: "requests",
    component: RequestsContainer,
  });

  const adminSystemRoute = createRoute({
    getParentRoute: () => adminParent,
    path: "system",
    component: RateLimitContainer,
  });

  return adminParent.addChildren([
    adminDashboardRoute,
    adminClientRoute,
    adminClientAddRoute,
    adminClientDetailRoute,
    adminClientEditRoute,
    adminRequestsRoute,
    adminSystemRoute,
  ]);
}
